import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
import { FORM_ERROR } from 'final-form';
import { connect } from 'react-redux';
import { isEmpty, isString } from 'lodash';
import { Collapse, Row, Col, Button } from 'antd';

import { TextField, ClassificatorField } from '../../atoms';
import { FormActions } from '../../components';
import {
  productionUnitFilterFields,
  PRODUCTION_UNIT_FILTER_FORM,
} from '../../constants/formProductionUnitFilter';
import * as actions from '../../actions/actionCreators/productionUnitListActionCreators';
import { parseNumber } from '../../utils/formHelpers';
import { isHydrogen } from '../../utils/productionUnitUtil';

import { updateFormState } from '../../reducers/reactFinalFormReducer';
import FormStateToRedux from '../FormStateToRedux';
import SubmitErrorToast from '../SubmitErrorToast';

const { Panel } = Collapse;

export class ProductionUnitFilter extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    searchProductionUnits: PropTypes.func.isRequired,
    fuelType: PropTypes.string,
    updateFormState: PropTypes.func.isRequired,
    initialValues: PropTypes.object.isRequired,
  };

  formApi = null;

  componentDidMount() {
    const values = this.props.initialValues;
    this.props.updateFormState(PRODUCTION_UNIT_FILTER_FORM, { values });
    this.props.searchProductionUnits(values);
  }

  onClear = () => {
    const values = this.props.initialValues;

    this.formApi.restart(values);

    this.props.updateFormState(PRODUCTION_UNIT_FILTER_FORM, { values });
    this.props.searchProductionUnits(values);
  };

  onSubmit = async (values) => {
    const { t, searchProductionUnits } = this.props;

    const allEmpty = Object.values(values || {}).every((v) => isEmpty(v));
    if (allEmpty) {
      return { [FORM_ERROR]: t('shouldFillAnyFilter') };
    }

    try {
      await searchProductionUnits(values);
      return;
    } catch (err) {
      const msg = err?.message ?? err;
      return { [FORM_ERROR]: isString(msg) ? msg : t('common.unknownError') };
    }
  };

  render() {
    const { t, fuelType, initialValues } = this.props;

    const isHydro = isHydrogen(fuelType);

    return (
      <div>
        <h2 className="main-header">
          {isHydro ? t('filter.hydroTitleSmall') : t('filter.titleSmall')}
        </h2>
        <div className="search-form-container">
          <Collapse>
            <Panel
              key="filters"
              header={isHydro ? t('filter.hydroTitle') : t('filter.title')}
            >
              <Form
                key={fuelType}
                initialValues={initialValues}
                onSubmit={this.onSubmit}
                subscription={{ submitting: true, pristine: true }}
                render={({ handleSubmit, form }) => {
                  this.formApi = form;
                  return (
                    <form onSubmit={handleSubmit}>
                      <FormStateToRedux form={PRODUCTION_UNIT_FILTER_FORM} />
                      <SubmitErrorToast />
                      <Row gutter={32}>
                        <Col span={8}>
                          <Field
                            label={t('filter.name')}
                            name={productionUnitFilterFields.NAME}
                            component={TextField}
                            hasFeedback={false}
                          />
                        </Col>
                        <Col span={8}>
                          <Field
                            label={t('filter.eicwCode')}
                            name={productionUnitFilterFields.EICW_CODE}
                            component={TextField}
                            hasFeedback={false}
                          />
                        </Col>
                        <Col span={8}>
                          <Field
                            label={t('filter.eicxCode')}
                            name={productionUnitFilterFields.EICX_CODE}
                            component={TextField}
                            hasFeedback={false}
                          />
                        </Col>
                      </Row>

                      <Row gutter={32}>
                        <Col span={8}>
                          <Field
                            label={t('filter.registerCode')}
                            name={productionUnitFilterFields.REGISTER_CODE}
                            component={TextField}
                            parse={parseNumber}
                            hasFeedback={false}
                          />
                        </Col>
                        <Col span={8}>
                          <Field
                            label={t('filter.status')}
                            name={productionUnitFilterFields.STATUS}
                            component={ClassificatorField}
                            classificatorType={
                              ClassificatorField.types.productionUnitStatus
                            }
                            hasFeedback={false}
                          />
                        </Col>
                      </Row>
                      <FormActions>
                        <Button onClick={this.onClear}>
                          {t('filter.clearBtn')}
                        </Button>
                        <Button type="primary" htmlType="submit">
                          {t('filter.submitBtn')}
                        </Button>
                      </FormActions>
                    </form>
                  );
                }}
              />
            </Panel>
          </Collapse>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (_state, ownProps) => ({
  initialValues: {
    [productionUnitFilterFields.PRODUCTION_DEVICE_TYPE]: ownProps.fuelType,
  },
});

const mapDispatchToProps = {
  ...actions,
  updateFormState,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductionUnitFilter);
